//#region src/service_charge_source.ts
var ServiceChargeSource = /* @__PURE__ */ function(ServiceChargeSource) {
	ServiceChargeSource["Bite"] = "bite";
	ServiceChargeSource["Pos"] = "pos";
	ServiceChargeSource["Payment"] = "payment";
	return ServiceChargeSource;
}(ServiceChargeSource || {});
//#endregion
export { ServiceChargeSource };

//# sourceMappingURL=service_charge_source.js.map